enum CallingProcessTypes {
  CMP = 0,
  EForms = 1,
  CMPMobile = 2
}


export default CallingProcessTypes;
